import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import style from './style/sepStyle';

const Sep = ({ classes, className, text, withMargin }) => {
  const rootClasses = cx({
    [classes.root]: true,
    [classes.withMargin]: withMargin,
    [className]: className !== undefined,
  });

  return (
    <hr
      className={rootClasses}
      {...(text && {
        'data-content': text,
      })}
    />
  );
};

Sep.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  noMargin: PropTypes.bool,
  text: PropTypes.string,
};

Sep.defaultProps = {
  className: '',
  withMargin: true,
};

export default withStyles(style)(Sep);
